var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.016,
    height: 14.788,
    viewBox: "0 0 12.016 14.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c0321f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.86,1.849H56.319V1.386A1.386,1.386,0,0,0,54.932,0H53.084A1.386,1.386,0,0,0,51.7,1.386v.462H49.155A1.155,1.155,0,0,0,48,3v.924a.462.462,0,0,0,.462.462H59.553a.462.462,0,0,0,.462-.462V3A1.155,1.155,0,0,0,58.86,1.849Zm-6.239-.462a.463.463,0,0,1,.462-.462h1.849a.463.463,0,0,1,.462.462v.462H52.621Z",
    transform: "translate(-48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.509,184a.144.144,0,0,0-.144.151l.381,8a1.385,1.385,0,0,0,1.385,1.321h7.018a1.385,1.385,0,0,0,1.385-1.321l.381-8A.144.144,0,0,0,83.77,184Zm6.979,1.155a.462.462,0,0,1,.924,0v6.008a.462.462,0,1,1-.924,0Zm-2.311,0a.462.462,0,0,1,.924,0v6.008a.462.462,0,1,1-.924,0Zm-2.311,0a.462.462,0,0,1,.924,0v6.008a.462.462,0,1,1-.924,0Z",
    transform: "translate(-72.632 -178.685)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRedIcon);
export default __webpack_public_path__ + "static/media/trash-red-icon.a3ce002a43d20e5640ed38b6d9ba0054.svg";
export { ForwardRef as ReactComponent };